import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const ServiceDetail = lazy(() => import('../pages/service-detail/page'));
const Products = lazy(() => import('../pages/products/page'));
const ProductDetail = lazy(() => import('../pages/product-detail/page'));
const TechnicalService = lazy(() => import('../pages/technical-service/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const BlogDetail = lazy(() => import('../pages/blog-detail/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/hakkimizda',
    element: <About />,
  },
  {
    path: '/hizmetler',
    element: <Services />,
  },
  {
    path: '/hizmetler/:slug',
    element: <ServiceDetail />,
  },
  {
    path: '/urunler',
    element: <Products />,
  },
  {
    path: '/urunler/:slug',
    element: <ProductDetail />,
  },
  {
    path: '/teknik-servis',
    element: <TechnicalService />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetail />,
  },
  {
    path: '/iletisim',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;